<template>
  <v-dialog width="800px" persistent v-model="addDialog">
    <template v-slot:activator="{ on }">
      <v-btn outlined v-on="on">
      <v-icon left>mdi-plus</v-icon>
      Add Channel
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Add Channel</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
      <v-card-subtitle>How to get your channel ID: https://www.youtube.com/channel/<span class="red--text">{your_channel_id}</span></v-card-subtitle>
        <v-text-field
          label="Channel ID"
          name="userId"
          id="userId"
          v-model="userId"
          :rules="rule1"
        >
        </v-text-field>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="formIsNotValid"
          class="ma-2"
          color="green"
          @click="addId"
        >
          <v-icon left>mdi-plus</v-icon>
          Add Channel
        </v-btn>
        <v-btn
          class="ma-2"
          color="grey"
          @click="addDialog=false"
        >
          <v-icon left>mdi-close</v-icon>
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['member'],
  data () {
    return {
      addDialog: false,
      userId: '',
      rule1: [
        value => !!value || 'Required',
        value => (value || '').length <= 40 || 'Max 40 characters'
      ],
      rule2: [
        value => !!value || 'Required',
        value => (value || '').length <= 100 || 'Max 100 characters'
      ]
    }
  },
  computed: {
    formIsNotValid () {
      return this.userId === ''
    }
  },
  methods: {
    addId () {
      if (this.formIsNotValid) {
        return
      }
      const info = {
        userId: this.userId
      }
      this.addDialog = false
      this.$store.dispatch('createChannelId', info)
    }
  }
}
</script>

<style>
  .red{
    color: red;
  }
</style>
